export default __webpack_public_path__ + "static/media/sponsor_2_light.602a670d.png";